module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("zAG6k"))).then(() => parcelRequire('1iHdE'));